import dayjs from "dayjs";

export function isDaysLeft(targetDate: string, day: number) {
    const today = dayjs().startOf('day'); // Текущая дата, начало дня
    const target = dayjs(targetDate).startOf('day'); // Целевая дата, начало дня
    const diff = target.diff(today, 'day'); // Разница в днях

    return diff <= day;
}
